module.exports = function() {
	return new Worker(__webpack_public_path__ + "c6cf5d75966a44b99a71.worker.js");
};


/*****************
 ** WEBPACK FOOTER
 ** ./~/worker-loader!./logic/move_worker.js
 ** module id = 342
 ** module chunks = 0
 **/